import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Typography from './Typography';
import Dialog from './Dialog';
import Button from './Button';

const styles = theme => ({
  dateInput: {
    cursor: 'pointer',
    padding: '0px 10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'calc(100% - 20px)',
    borderRadius: 5,
    backgroundColor: '#e9e9e9',
    height: 30
  },
  iconContainer: {
    width: 35,
    minHeight: 35,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: '1px solid #969696'
  },
  inputContainer: {
    width: 'calc(100% - 55px)',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 10px'
  },
  dropDownContainer: {
    borderRadius: 4,
    width: '100%',
    height: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #969696',
    cursor: 'pointer'
  },
  elipsContainer: {
    width: 'calc(100% - 10px)',
    display: 'flex',
    justifyContent: 'center',
    padding: '5px 5px',
    border: '1px solid #bfbfbf',
    borderRadius: 25,
    cursor: 'pointer'
  },
  customContainer: {
    cursor: 'pointer'
  }
});

const ConfirmationDialog = props => {
  const {
    classes,
    open,
    onClose,
    handleNoConf,
    handleYesConf,
    message,
    customMessage,
    withCloseButton = false,
    yesLabel = 'Ya',
    noLabel = 'Tidak',
    ...rest
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      withoutCloseButton={!withCloseButton}
      maxWidth='sm'
      fullScreen={false}
      paddingContent={15}
      {...rest}
    >
      {customMessage || <Typography type='bold'>
        {message || 'Apakah anda yakin?'}
      </Typography>
      }
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          type='oval'
          color="#ef4040"
          onClick={withCloseButton ? handleNoConf : onClose}
          style={{ margin: 5 }}
        >
          <Typography variant='body1' color='#FFFFFF'>
            {noLabel}
          </Typography>
        </Button>
        <Button
          type='oval'
          color="#0073d1"
          onClick={handleYesConf}
          style={{ margin: 5 }}
        >
          <Typography variant='body1' color='#FFFFFF'>
            {yesLabel}
          </Typography>
        </Button>

      </div>
    </Dialog>
  )
}

ConfirmationDialog.propTypes = {
  classes: PropTypes.isRequired,
  // Jika true maka pop up konfirmasi akan muncul, jika false maka akan tertutup
  open: PropTypes.bool,
  // Fungsi ketika klik button close
  onClose: PropTypes.func,
  // Fungsi ketika klik button konfirmasi
  handleYesConf: PropTypes.func,
  // Pesan yang ingin ditampilkan di button konfirmasi
  message: PropTypes.string
};

export default withStyles(styles)(ConfirmationDialog);
